// import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import Button from 'partial/components/Button';
import { HiOutlineFolder } from 'react-icons/hi';
// import Bread, { BreadItem } from 'partial/components/Bread';
import AppPreview from '../components/AppPreview';
import SliderCms from '../components/SliderCms';
import SliderSquareCms from '../components/SliderSquareCms';
import ServicesCms from '../components/ServicesCms';
import PanelList from '../components/PanelList';

function AppCmsContainer() {
  const [panels] = React.useState([
    { id: '1', type: 'WALLET', label: 'Wallet' },
    { id: '2', type: 'MAIN_MODULE', label: 'Main Services' },
    { id: '3', type: 'SUB_MODULE', label: 'Other Services' },
    { id: '4', type: 'SLIDER', label: 'Discover' },
    { id: '5', type: 'SLIDER_SQUARE', label: 'Advertisements' },
  ]);
  const [showPreview, setShowPreview] = React.useState(true);
  const [selected, handleSetSelected] = React.useState(null);
  const setSelected = React.useCallback(
    (v) => {
      if (v) setShowPreview(false);
      handleSetSelected(v);
    },
    [handleSetSelected, setShowPreview]
  );

  const [panel, handleSetPanel] = React.useState(null);
  const setPanel = React.useCallback(
    (v) => {
      setShowPreview(true);
      handleSetSelected(null);
      handleSetPanel(v);
    },
    [handleSetPanel, setShowPreview, handleSetSelected]
  );

  const renderCms = React.useMemo(() => {
    if (panel?.type === 'SUB_MODULE')
      return <ServicesCms data={panel} onSelect={setSelected} />;
    if (panel?.type === 'SLIDER')
      return <SliderCms data={panel} onSelect={setSelected} />;
    if (panel?.type === 'SLIDER_SQUARE')
      return <SliderSquareCms data={panel} onSelect={setSelected} />;
    return (
      <div className="px-4 py-8">
        <div className="border-4 border-dashed border-gray-200 rounded-lg h-96 flex">
          <div className="m-auto text-gray-400">
            <div className="text-center">
              <HiOutlineFolder className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">Empty</h3>
              <p className="mt-1 text-sm text-gray-500">
                There are no settings for this panel
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }, [panel, setSelected]);

  const renderSettings = React.useMemo(() => {
    console.log(panel, selected); // eslint-disable-line
    return (
      <div className="px-4 py-8">
        <div className="border-4 border-dashed border-gray-200 rounded-lg h-96 flex">
          <div className="m-auto text-gray-400">
            <div className="text-center">
              <HiOutlineFolder className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                Settings
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                There are no configuration.
              </p>
              <div className="flex justify-center mt-3">
                <Button
                  onClick={() => setShowPreview((state) => !state)}
                  type="button"
                >
                  Back to preview.
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }, [panel, selected, setShowPreview]);

  return (
    <>
      {/* <Bread>
        <BreadItem home label="All Panels" />
        {selected && <BreadItem label={selected?.label} />}
      </Bread> */}
      <div className="flex-1 relative z-0 flex overflow-hidden border-t border-gray-200">
        <aside className="hidden relative xl:order-first xl:flex xl:flex-col flex-shrink-0 w-72 border-r border-gray-200">
          <PanelList panels={panels} selected={panel} setSelected={setPanel} />
        </aside>
        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
          {renderCms}
        </main>
        <aside className="hidden relative right-0 xl:flex xl:flex-col flex-shrink-0 w-96 border-l border-gray-200">
          <Transition
            as={Fragment}
            show={showPreview}
            enter="ease-out duration-300 z-10"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <div className="absolute h-full w-full overflow-y-scroll">
              <AppPreview panels={panels} />
            </div>
          </Transition>
          <Transition
            as={Fragment}
            show={!showPreview}
            enter="ease-out duration-300 z-10"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <div className="absolute h-full w-full overflow-y-scroll">
              {renderSettings}
            </div>
          </Transition>
        </aside>
      </div>
    </>
  );
}

AppCmsContainer.propTypes = {};

export default AppCmsContainer;
